module.exports = __webpack_public_path__ + "static/media/chart-21.37e06352.svg";